import { Route, Routes } from 'react-router-dom';
import protect from './protect/protect';
import { PERMISSION } from '@/user/permissions/permission.type';
import { ProjectOverviewPage } from '@/features/projects/project-overview.page';
import { ProjectsPage } from '@/features/projects/projects.page';
import { NewProjectPage } from '@/features/projects/new-project.page';

export const Projects = () => {
  return (
    <Routes>
      <Route index element={<ProjectsPage />} />
      <Route
        path="create"
        element={protect(
          <NewProjectPage />,
          { permissions: [PERMISSION.ADD_PROJECT] },
          { navigateToNotFound: true },
        )}
      />
      <Route
        path=":projectId"
        element={protect(<ProjectOverviewPage />, {
          permissions: [PERMISSION.VIEW_PROJECT_HOME_PAGE],
        })}
      />
    </Routes>
  );
};
